import type { FC } from 'react';
import type { ControlProps, GroupBase, OptionProps, PlaceholderProps } from 'react-select';
import { components } from 'react-select';

import type { SelectOptionT } from 'declarations/types/select';

import { ControlStyled, OptionStyled, PlaceholderStyled } from './Select.styled';

const Control: FC<ControlProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children } = props;

  return (
    <components.Control {...props} getStyles={(): Record<string, never> => ({})}>
      <ControlStyled>{children}</ControlStyled>
    </components.Control>
  );
};

const Placeholder: FC<PlaceholderProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children } = props;

  return (
    <components.Placeholder {...props}>
      <PlaceholderStyled size="xl">{children}</PlaceholderStyled>
    </components.Placeholder>
  );
};

const Option: FC<OptionProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children, isFocused, isSelected } = props;

  return (
    <components.Option {...props} getStyles={(): Record<string, never> => ({})}>
      <OptionStyled isFocused={isFocused} isSelected={isSelected}>
        {children}
      </OptionStyled>
    </components.Option>
  );
};

export { Control, Placeholder, Option };
